<template>
  <div v-if="auditConfig && auditSites && auditSamplingType !== undefined">
    <div>
      <b-field :class="$style.SamplingTypeDropdown" label="Sampling Type">
        <b-dropdown
          aria-role="list"
          @change="handleSamplingTypeChange"
          v-model="auditSamplingType"
          class="auditSamplingTypeContainer"
        >
          <button
            class="button"
            :class="$style.auditSamplingTypeDropdown"
            slot="trigger"
            slot-scope="{ active }"
          >
            <span>{{ samplingTypeOptions[auditSamplingType] }}</span>
            <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
          </button>

          <template v-for="(value, key) in samplingTypeOptions">
            <b-dropdown-item :key="key" aria-role="listitem" :value="key">{{
              value
            }}</b-dropdown-item>
          </template>
        </b-dropdown>
      </b-field>

      <b-field
        :class="$style.SamplingModeDropdown"
        label="Mode"
        v-if="
          auditSamplingType === 'targetSampleSize' &&
          auditSiteType === 'multiSite'
        "
      >
        <b-dropdown
          aria-role="list"
          v-model="auditSamplingMode"
          class="auditSamplingTypeContainer"
        >
          <button
            class="button"
            :class="$style.auditSamplingTypeDropdown"
            slot="trigger"
            slot-scope="{ active }"
          >
            <span>{{ samplingModeDisplayOptions[auditSamplingMode] }}</span>
            <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
          </button>

          <template v-for="(value, key) in samplingModeDisplayOptions">
            <b-dropdown-item :key="key" aria-role="listitem" :value="key">{{
              value
            }}</b-dropdown-item>
          </template>
        </b-dropdown>
      </b-field>

      <b-field
        :class="$style.SamplingModeDropdown"
        label="Value Control"
        v-if="auditSamplingType === 'consecutive'"
      >
        <b-dropdown
          aria-role="list"
          v-model="consecutiveSamplingMode"
          @change="handleSamplingModeChange"
          class="auditSamplingTypeContainer"
        >
          <button
            class="button"
            :class="$style.auditSamplingTypeDropdown"
            slot="trigger"
            slot-scope="{ active }"
          >
            <span>{{
              consecutiveSamplingModeDisplayOptions[consecutiveSamplingMode]
            }}</span>
            <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
          </button>

          <template
            v-for="(value, key) in consecutiveSamplingModeDisplayOptions"
          >
            <b-dropdown-item :key="key" aria-role="listitem" :value="key">{{
              value
            }}</b-dropdown-item>
          </template>
        </b-dropdown>
      </b-field>
    </div>
    <TargetSampleSizeSingleSiteSampling
      v-if="
        auditSamplingType === 'targetSampleSize' &&
        auditSiteType === 'singleSite'
      "
      :auditId="auditId"
      :auditSamplingType="auditSamplingType"
      :auditConfig="auditConfig"
      :auditCategory="auditCategory"
      :editable="editable"
    ></TargetSampleSizeSingleSiteSampling>

    <TargetSampleSizeMultiSiteCriteriaSampling
      v-if="
        auditSamplingType === 'targetSampleSize' &&
        auditSiteType === 'multiSite'
      "
      :auditSamplingType="auditSamplingType"
      :auditSamplingMode="auditSamplingMode"
      :auditConfig="auditConfig"
      :auditSiteList="auditSites"
      :auditId="auditId"
      :auditCategory="auditCategory"
      :editable="editable"
    >
    </TargetSampleSizeMultiSiteCriteriaSampling>

    <ConsecutiveTargetSampleSingleSiteSampling
      v-if="
        auditSamplingType === 'consecutive' &&
        auditSiteType === 'singleSite' &&
        consecutiveSamplingMode === 'targetSample'
      "
      :auditId="auditId"
      :auditSamplingType="auditSamplingType"
      :auditConfig="auditConfig"
      :consecutiveSamplingMode="consecutiveSamplingMode"
      :auditCategory="auditCategory"
      :editable="editable"
    ></ConsecutiveTargetSampleSingleSiteSampling>

    <ConsecutiveTargetSampleMultiSiteSampling
      v-if="
        auditSamplingType === 'consecutive' &&
        auditSiteType === 'multiSite' &&
        consecutiveSamplingMode === 'targetSample'
      "
      :auditSamplingType="auditSamplingType"
      :consecutiveSamplingMode="consecutiveSamplingMode"
      :auditConfig="auditConfig"
      :auditSiteList="auditSites"
      :auditId="auditId"
      :auditCategory="auditCategory"
      :editable="editable"
    >
    </ConsecutiveTargetSampleMultiSiteSampling>

    <ConsecutiveMinAndMaxSingleSiteSampling
      v-if="
        auditSamplingType === 'consecutive' &&
        auditSiteType === 'singleSite' &&
        consecutiveSamplingMode === 'minAndMax'
      "
      :auditId="auditId"
      :auditSamplingType="auditSamplingType"
      :auditConfig="auditConfig"
      :consecutiveSamplingMode="consecutiveSamplingMode"
      :validateCurrentDataEntryValue="validateDataEntry"
      :editable="editable"
    ></ConsecutiveMinAndMaxSingleSiteSampling>

    <ConsecutiveMinAndMaxMultiSiteSampling
      v-if="
        auditSamplingType === 'consecutive' &&
        auditSiteType === 'multiSite' &&
        consecutiveSamplingMode === 'minAndMax'
      "
      :auditSamplingType="auditSamplingType"
      :consecutiveSamplingMode="consecutiveSamplingMode"
      :auditConfig="auditConfig"
      :auditSiteList="auditSites"
      :auditId="auditId"
      :validateCurrentDataEntryValue="validateDataEntry"
      :editable="editable"
    ></ConsecutiveMinAndMaxMultiSiteSampling>

    <AdHocSingleSiteSampling
      v-if="auditSamplingType === 'adHoc' && auditSiteType === 'singleSite'"
      :auditId="auditId"
      :auditSamplingType="auditSamplingType"
      :auditConfig="auditConfig"
      :auditDataCollectionDate="auditDataCollectionDate"
      :editable="editable"
    ></AdHocSingleSiteSampling>
    <AdHocMultiSiteSampling
      v-if="auditSamplingType === 'adHoc' && auditSiteType === 'multiSite'"
      :auditConfig="auditConfig"
      :auditSiteList="auditSites"
      :auditId="auditId"
      :auditSamplingType="auditSamplingType"
      :auditDataCollectionDate="auditDataCollectionDate"
      :editable="editable"
    ></AdHocMultiSiteSampling>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  AuditSamplingRequestPayload,
  AuditSamplingResponse,
  AuditSamplingTypeDisplayOptions,
  AuditSite,
  ConsecutiveSamplingModeDisplayOptions,
  SamplingModeDisplayOptions,
} from '@/store/modules/audits/types/audits.types';
import TargetSampleSizeSingleSiteSampling from '@/views/Audit/components/TargetSampleSizeSingleSiteSampling.vue';
import TargetSampleSizeMultiSiteCriteriaSampling from '@/views/Audit/components/TargetSampleSizeMultiSiteCriteriaSampling.vue';
import ConsecutiveTargetSampleSingleSiteSampling from '@/views/Audit/components/ConsecutiveTargetSampleSingleSiteSampling.vue';
import ConsecutiveTargetSampleMultiSiteSampling from '@/views/Audit/components/ConsecutiveTargetSampleMultiSiteSampling.vue';
// tslint:disable-next-line:max-line-length
import ConsecutiveMinAndMaxSingleSiteSampling from '@/views/Audit/components/ConsecutiveMinAndMaxSingleSiteSampling.vue';
import ConsecutiveMinAndMaxMultiSiteSampling from '@/views/Audit/components/ConsecutiveMinAndMaxMultiSiteSampling.vue';
import AdHocSingleSiteSampling from '@/views/Audit/components/AdHocSingleSiteSampling.vue';
import AdHocMultiSiteSampling from '@/views/Audit/components/AdHocMultiSiteSampling.vue';
import { Action, State } from 'vuex-class';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import ConfirmationDialogue from '@/components/ConfirmationDialogue.vue';
import {
  AuditSamplingType,
  ConsecutiveSamplingMode,
  SamplingMode,
} from '@/jbi-shared/types/project.types';

@Component({
  components: {
    ConfirmationDialogue,
    AdHocMultiSiteSampling,
    AdHocSingleSiteSampling,
    ConsecutiveMinAndMaxMultiSiteSampling,
    ConsecutiveMinAndMaxSingleSiteSampling,
    ConsecutiveTargetSampleMultiSiteSampling,
    ConsecutiveTargetSampleSingleSiteSampling,
    TargetSampleSizeMultiSiteCriteriaSampling,
    TargetSampleSizeSingleSiteSampling,
  },
})
export default class AuditSampling extends Vue {
  @Prop()
  public auditId!: number;
  @Prop()
  public auditDataCollectionDate!: string;
  @Prop()
  public auditCategory!: string;
  @Prop({ default: true })
  public editable!: boolean;

  //TODO: add typebind with available enums from jbi-shared across file
  public auditSamplingType: AuditSamplingType =
    AuditSamplingType.TARGET_SAMPLE_SIZE;
  public auditSamplingMode: SamplingMode = SamplingMode.SITE_BASED;
  public consecutiveSamplingMode: ConsecutiveSamplingMode =
    ConsecutiveSamplingMode.TARGET_SAMPLE;
  public isFirstTimeMounted: boolean = true;
  public previousSamplingType: AuditSamplingType =
    AuditSamplingType.TARGET_SAMPLE_SIZE;
  public validateDataEntry: boolean = false;

  @Action('audits/getAuditSites')
  public getAuditSites!: (payload: number) => void;

  @State((state) => state.audits.auditSites)
  public auditSites!: AuditSite[];

  @Action('audits/getSamplingConfig')
  public getSamplingConfig!: (payload: AuditSamplingRequestPayload) => void;

  @State((state) => state.audits.auditConfig)
  public auditConfig!: AuditSamplingResponse;

  @Watch('auditConfig')
  @isTruthy
  public watchAuditConfig(newValue: AuditSamplingResponse) {
    if (this.isFirstTimeMounted) {
      this.auditSamplingType = newValue.auditSamplingConfigs.auditSamplingType;
      this.previousSamplingType = this.auditSamplingType;
      if (this.auditSamplingType === AuditSamplingType.TARGET_SAMPLE_SIZE) {
        this.auditSamplingMode = newValue.auditSamplingConfigs
          .samplingMode as any;
      } else if (this.auditSamplingType === AuditSamplingType.CONSECUTIVE) {
        this.consecutiveSamplingMode = newValue.auditSamplingConfigs
          .samplingMode as any;
        this.validateDataEntry =
          newValue.auditSamplingConfigs.validateDataEntry;
      }
      this.isFirstTimeMounted = false;
    }
  }

  public mounted() {
    this.getSamplingConfig({
      auditId: this.auditId,
    });
    this.getAuditSites(this.auditId);
  }

  get samplingTypeOptions() {
    return AuditSamplingTypeDisplayOptions;
  }

  get samplingModeDisplayOptions() {
    return SamplingModeDisplayOptions;
  }

  get consecutiveSamplingModeDisplayOptions() {
    return ConsecutiveSamplingModeDisplayOptions;
  }

  public handleSamplingTypeChange(newValue: AuditSamplingType) {
    if (
      this.auditDataCollectionDate !== undefined &&
      this.auditDataCollectionDate !== null
    ) {
      let confirmationText = `Changing the sampling type will change
                    the sampling information displayed in the data collection page.`;
      if (newValue === AuditSamplingType.AD_HOC) {
        confirmationText = `Changing the sampling type to Ad-Hoc will cease data collection
                    and delete collected data for criteria disabled for sampling.`;
      }
      this.$buefy.modal.open({
        parent: this,
        component: ConfirmationDialogue,
        hasModalCard: true,
        trapFocus: true,
        onCancel: () => {
          this.auditSamplingType = this.previousSamplingType;
        },
        props: {
          modalTitle: 'Change Sampling Type?',
          confirmationText,
          confirmationButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
        },
        events: {
          confirm: () => {
            this.previousSamplingType = newValue;
            this.auditSamplingType = newValue;
            this.getSamplingConfig({
              auditId: this.auditId,
              samplingType: newValue,
            });
          },
          cancel: () => {
            this.auditSamplingType = this.previousSamplingType;
          },
        },
      });
    } else {
      this.previousSamplingType = newValue;
      this.auditSamplingType = newValue;
      this.getSamplingConfig({
        auditId: this.auditId,
        samplingType: newValue,
      });
    }
  }

  public handleSamplingModeChange() {
    this.getSamplingConfig({
      auditId: this.auditId,
      samplingType: this.auditSamplingType,
      mode: this.consecutiveSamplingMode,
    });
  }

  get auditSiteType() {
    return this.auditSites && this.auditSites.length > 1
      ? 'multiSite'
      : 'singleSite';
  }
}
</script>
<style lang="scss" module>
.backContainer a {
  color: #444f51;
  font-size: 20px;
  font-weight: 400;
}
.tabLabel nav li a {
  padding-left: 0;
  color: #9f9f9f;
  font-size: 16px;
  font-weight: 700;
}
.tabLabel nav li {
  padding-right: 2rem;
}
.auditTitle {
  color: #00205b;
  font-size: 40px;
  font-weight: 700;
}
.projectTitle {
  color: #444f51;
  font-size: 20px;
}
.tableName {
  color: #444f51;
}
.tableContainer {
  padding: 18px 20px;
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
  thead {
    background-color: #ffffff;
  }
  tbody {
    background-color: #ffffff;
  }
}
.saveChangesBtn {
  float: right;
  border-radius: 24px;
  height: 48px;
  width: 150px;
  padding: 0 calc(1em + 0.25em);
}
.headerContainer {
  padding: 1rem 0;
}
.headerRightIcon {
  padding-right: 15px;
  color: #9f9f9f;
  font-size: 14px;
}
.headerRightText {
  color: #444f51;
}
.title {
  color: #444f51;
}

.tabLabel > section {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.noDataMessageContainer {
  text-align: center;
  vertical-align: middle;
  height: 100%;
}
.noDataMessage {
  line-height: 30;
  color: #9f9f9f;
  font-size: 18px;
}
.tabItem {
  padding-top: 42px;
}
.projectTitleContainer {
  padding-top: 15px;
}
.headerStartText {
  color: #00205b;
  font-size: 18px;
  font-weight: 700;
}
.headerTitleColumn {
  padding: 0 0.75rem;
}
.paddingTop {
  padding-top: 30px;
}
.criteriaBasedLabel {
  padding-top: 40px;
}

.auditSamplingTypeDropdown,
.auditSamplingTypeDropdown:hover {
  color: #444f51;
  line-height: 18px;
  font-weight: initial !important;
  width: 320px;
  justify-content: space-between;
  padding: 10px 12px;
  border-color: #dfdfdf;
}

.calculatorIcon {
  padding-right: 0px !important;
  padding-left: 0px !important;
  div {
    justify-content: end;
  }
  img {
    width: 18px;
    height: 18px;
  }
  img:hover {
    cursor: pointer;
  }
}
.SamplingTypeDropdown {
  display: inline-block;
}
.SamplingModeDropdown {
  display: inline-block;
  padding-left: 16px;
}
</style>
